module.exports = __webpack_public_path__ + "static/media/howtowatch.135a7ec4.png";